import { IInquiryDocumentUpload } from '../..'
import { INewQuoteForm } from '../../schema'
import { useUpFetch } from '../../utils'

export const useLoadsApi = () => {
  const upFetch = useUpFetch()

  const deleteLoad = async (loadId: number) => {
    return upFetch(`/loads/${loadId}`, {
      method: 'DELETE',
    })
  }

  const editLoad = async (data: INewQuoteForm) => {
    return upFetch<{ data: { id: number } }>(`/loads/${data.id}`, {
      body: data,
      method: 'PATCH',
    })
  }

  const patchLoadAddress = async ({
    addressId,
    dropId,
    loadId,
  }: {
    addressId: number
    dropId: number
    loadId: number
  }) =>
    upFetch(`/loads/${loadId}/drop/${dropId}/address`, {
      body: {
        address_id: addressId,
      },
      method: 'PATCH',
    })

  const addInquiryDoc = async (loadId: number, document: IInquiryDocumentUpload) => {
    const formData = new FormData()

    formData.append('type', document.type ?? 'other')
    formData.append('files[]', document.file)

    await upFetch<{ data: IInquiryDocumentUpload }>(`/loads/${loadId}/documents`, {
      body: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'POST',
    })
  }

  const deleteInquiryDoc = async (loadId: number, documentId: number) => {
    await upFetch(`/loads/${loadId}/documents/${documentId}`, {
      method: 'DELETE',
    })
  }

  const getInquiryDocDownloadUrl = async (loadId: number, documentId: number) => {
    const res = await upFetch<{ url: string }>(`/loads/${loadId}/documents/${documentId}/download`)

    return res.url
  }

  const postAttachAssignUser = async ({ loadId, userId }: { loadId: number; userId: number }) => {
    return await upFetch(`loads/${loadId}/assignee/${userId}/attach`, {
      method: 'POST',
    })
  }

  const postDetachAssignUser = async ({ loadId, userId }: { loadId: number; userId: number }) => {
    return await upFetch(`loads/${loadId}/assignee/${userId}/detach`, {
      method: 'POST',
    })
  }

  return {
    addInquiryDoc,
    deleteInquiryDoc,
    deleteLoad,
    editLoad,
    getInquiryDocDownloadUrl,
    patchLoadAddress,
    postAttachAssignUser,
    postDetachAssignUser,
  }
}
